// modules
import account from './account/index'
import config from './config/index'
import nav from './nav/index'
import home from './home/index'
import ranking from './ranking/index'
import mybet from './mybet/index'
import timer from './timer/index'
import share from './share/index'
import comment from './comment/index'

const modules = {
    account,
    config,    
    nav,
    home,
    ranking,
    mybet,
    timer,
    share,
    comment
}

export default modules
